import { NgModule } from '@angular/core';
import { EmailPerformanceComponent } from './email-performance/email-performance.component';
import { EmailStatsComponent } from './email-stats.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCardModule } from '@angular/material/card';
import { GalaxyStatisticModule } from '@vendasta/galaxy/statistic';
import { MatGridListModule } from '@angular/material/grid-list';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DeliveryStatusComponent } from './delivery-status/delivery-status.component';
import { LinkPerformanceComponent } from './link-performance/link-performance.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [EmailPerformanceComponent, EmailStatsComponent, DeliveryStatusComponent, LinkPerformanceComponent],
  imports: [
    CommonModule,
    RouterModule,
    MatCardModule,
    MatTooltipModule,
    GalaxyStatisticModule,
    MatGridListModule,
    MatExpansionModule,
    TranslateModule,
    MatButtonModule,
  ],
  exports: [EmailStatsComponent, LinkPerformanceComponent],
  providers: [],
})
export class EmailStatsModule {}
